export const blockIconsMapsLocationOnNew = (
	<span className='material-symbols-outlined'>location_on</span>
);
